import { LoadingOutlined } from "@ant-design/icons";
import { Spin, type SpinProps } from "antd";

export function CustomSpin(props: SpinProps) {
	return <Spin {...props} size="large" style={{ display: "inline-block" }} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin={true} />} />;
}
